<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <TaxiSearchBox @search="search" @clear="clear" :query="query"></TaxiSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
            <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
          </v-flex>
          <TaxiList
            v-if="!loading"
            style="width: 100%;"
            :taxis="taxis"
            :rideTypes="rideTypes"
            :paginationProp="pagination"
          ></TaxiList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import TaxiList from "@/components/taxi/TaxiList.vue";
import TaxiSearchBox from "@/components/taxi/TaxiSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "taxis",
  components: {
    SimpleCard,
    TaxiList,
    TaxiSearchBox
  },

  data: function() {
    return {
      taxis: [],
      offset: 0,
      count: 20,
      query: {
        verification: "",
        search: "",
        numPassengers: 4
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0
    };
  },
  mounted: async function() {
    this.getTaxis();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getTaxis();
    },
    clear: function() {
      this.query = {
        search: "",
        lockedOut: false
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.getTaxis();
    },
    getTaxis: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/taxi/list?offset=${this.count *
          (this.pagination.page - 1)}&count=${this.count}
        &query=${this.query.search}&verificationState=${this.query.verification}&numPassengers=${this.query.numPassengers}`;

        let response = await axios.get(url, {
          params: {}
        });

        var taxis = response.data.taxis;

        this.taxis = taxis;

        this.rideTypes = response.data.ride_types;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get taxis " + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    }
  }
};
</script>
